module.exports = "/assets/b7f7ae7d32bdc0df9dbb806c57404853.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VY.png
// module id = 3062
// module chunks = 0